export default __webpack_public_path__ + "static/media/newHabitTrackerHabitMoreInfoBig.e35d342b.png";